import { isArray } from '@/util/inspect'
import { AlertTriangleIcon, CheckCircleIcon } from 'vue-feather-icons'

export default {
  methods: {
    toastErrorResponse(e) {
      let title
      if (e?.response?.data?.message) {
        const { errors } = e.response.data.error

        if (isArray(errors) && errors.length) {
          title = errors[0]
        }
      } else if (e?.message) {
        title = e.message
      } else {
        title = e
      }

      this.$toast.error(title, {
        icon: AlertTriangleIcon,
      })

      console.error('toast_error_response', e)
    },

    toastSuccessResponse(title) {
      this.$toast.success(title, {
        icon: CheckCircleIcon,
      })
    },
  },
}
